<template>
    <el-dialog
        class="detail"
        :visible.sync="detailVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="1500px"
        title="Detail Product"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container" v-loading="loading">
            <el-form ref="detailForm" :model="detailForm" label-width="110px" :disabled="disabled" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="12">
                        <el-col :span="24">
                            <el-form-item
                                label="Product Type"
                                :rules="[
                                    {
                                        required: true,
                                        message: ``,
                                    },
                                ]"
                                prop="type"
                                size="small"
                            >
                                <el-radio-group
                                    v-model="detailForm.type"
                                    @change="typeChange"
                                >
                                    <el-radio :label="1">{{
                                        $i18n.locale == "zh" ? "是" : "Single"
                                    }}</el-radio>
                                    <el-radio :label="2">{{
                                        $i18n.locale == "zh"
                                            ? "否"
                                            : "Multi Attribute"
                                    }}</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Product Name"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input Product Name',
                                    },
                                ]"
                                prop="goods_name"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="detailForm.goods_name"
                                    placeholder="Please input Product Name"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Category"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input Category',
                                    },
                                ]"
                                prop="catalog_id"
                                size="small"
                            >
                                <!-- <el-input
                                    clearable
                                    size="small"
                                    v-model="detailForm.category"
                                    placeholder="Please input Category"
                                ></el-input> -->
                                <el-cascader
                                    disabled
                                    filterable
                                    clearable
                                    :options="treeData"
                                    :props="cascaderProps"
                                    v-model="detailForm.catalog_id"
                                    style="width: 100%"
                                    placeholder="Plaese Select Category"
                                    size="small"
                                    :show-all-levels="false"
                                >
                                </el-cascader>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="SPU"
                                :rules="[
                                    {
                                        required: true,
                                        message: 'Please input SPU',
                                    },
                                ]"
                                prop="spu"
                                size="small"
                            >
                                <el-input
                                    clearable
                                    placeholder="Please input SPU"
                                    maxlength="200"
                                    size="small"
                                    v-model="detailForm.spu"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item label="Tag" size="small" prop="tags">
                                <tagsInput
                                    :tagsList.sync="detailForm.tags"
                                    title="Tag"
                                    :visible="detailVisible"
                                    :disabled="true"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Keyword"
                                size="small"
                                prop="keyword"
                            >
                                <tagsInput
                                    :tagsList.sync="detailForm.keyword"
                                    title="Keyword"
                                    :visible="detailVisible"
                                    :disabled="true"
                                ></tagsInput>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="New Arrivals"
                                size="small"
                                prop="new_arrival_date"
                            >
                                <el-date-picker
                                    v-model="detailForm.new_arrival_date"
                                    type="date"
                                    placeholder="Please select"
                                    value-format="yyyy-MM-dd"
                                >
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Promotion"
                                size="small"
                                :label-width="
                                    $i18n.locale == 'zh' ? '100px' : '110px'
                                "
                                prop="promotion"
                            >
                                <el-checkbox
                                    v-model="detailForm.promotion"
                                    :label="1"
                                    :true-label="1"
                                    >Yes</el-checkbox
                                >
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Private Products"
                                size="small"
                                prop="private_user_id"
                            >
                                <el-input
                                    clearable
                                    size="small"
                                    v-model="detailForm.private_user_id"
                                    placeholder="Please input Private Products"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="24">
                            <el-form-item
                                label="Status"
                                size="small"
                                prop="status"
                                style="text-align: left"
                            >
                                <el-radio-group v-model="detailForm.status">
                                    <el-radio :label="1">On Sale</el-radio>
                                    <el-radio :label="5">Pending</el-radio>
                                    <el-radio :label="60">Eliminated</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </el-col>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Picture"
                            size="small"
                            prop="goods_images"
                        >
                            <imgUpload
                                :images="detailForm.goods_images"
                                ref="uploadsRef"
                                @imagesChange="imagesChange"
                                :readonly="true"
                                :multiple="true"
                            />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item
                            label="Description"
                            size="small"
                            prop="goods_desc"
                        >
                            <vue-tinymce
                                v-model="detailForm.goods_desc"
                                :setting="setting"
                                v-if="detailVisible"
                            />
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <div class="table">
                            <el-table
                                border
                                :data="detailForm.attributes"
                                ref="attributes"
                                highlight-current-row
                                max-height="500px"
                            >
                                <el-table-column
                                    label="Images"
                                    align="center"
                                    width="80"
                                >
                                    <template slot-scope="scope">
                                        <el-image
                                            style="width: 60px; height: 60px"
                                            class="elImage_show"
                                            :src="scope.row.images[0]"
                                            fit="contain"
                                            @click="updateImg(scope)"
                                        >
                                            <div
                                                slot="error"
                                                class="image-slot"
                                            >
                                                <i
                                                    class="
                                                        el-icon-picture-outline
                                                    "
                                                ></i>
                                            </div>
                                            <div
                                                slot="placeholder"
                                                class="image-slot"
                                            >
                                                <i class="el-icon-loading"></i>
                                            </div>
                                        </el-image>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="SKU"
                                    align="center"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.sku'
                                            "
                                        >
                                            <el-input
                                                clearable
                                                placeholder="SKU"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.sku"
                                            ></el-input>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Combination SKU"
                                    align="center"
                                    prop="is_combine_sku"
                                     width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.is_combine_sku'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.is_combine_sku"
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of combineList"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Weight"
                                    align="center"
                                    prop="upc"
                                    width="140"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            clearable
                                            placeholder="Weight"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.weight"
                                        >
                                            <template slot="append"
                                                >g</template
                                            >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="LWH (mm)"
                                    align="center"
                                    prop="lwh"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            class="lwh_input"
                                            placeholder="LWH"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.lwh"
                                        >
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Price"
                                    align="center"
                                    prop="price"
                                    width="160"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Price"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.price"
                                        >
                                            <template slot="prepend"
                                                >Price $</template
                                            >
                                        </el-input>
                                        <div style="margin-top: 5px;" v-if="scope.row.mspr > 0">
                                            <el-input
                                                placeholder="Price"
                                                maxlength="100"
                                                size="small"
                                                v-model="scope.row.mspr"
                                            >
                                                <template slot="prepend"
                                                    >MSRP $</template
                                                >
                                            </el-input>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Stock "
                                    align="center"
                                    prop="stock"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Stock"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.stock"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    label="Delivery Time"
                                    align="center"
                                    prop="value"
                                    width="130"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Please input Delivery Time"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.delivery_time"
                                        ></el-input>
                                    </template>
                                </el-table-column> -->
                                <el-table-column
                                    label="Tags"
                                    align="center"
                                    prop="tags"
                                    width="180"
                                >
                                    <template slot-scope="scope">
                                        <el-cascader
                                            popper-class="tags_cascader"
                                            disabled
                                            filterable
                                            clearable
                                            :options="goodsTagList"
                                            :props="tagsCascaderProps"
                                            v-model="scope.row.tags"
                                            style="width: 100%"
                                            placeholder="Plaese Select Tags"
                                            size="small"
                                            :show-all-levels="false"
                                        >
                                        </el-cascader>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Value"
                                    align="center"
                                    prop="value"
                                >
                                    <template slot-scope="scope">
                                        <el-input
                                            placeholder="Value"
                                            maxlength="100"
                                            size="small"
                                            v-model="scope.row.value"
                                        ></el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Type"
                                    align="center"
                                    prop="delivery_type"
                                    width="120"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.delivery_type'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.delivery_type"
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of deliveryType"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="ProcessingTime"
                                    align="center"
                                    prop="processing_time"
                                     width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: false }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.processing_time'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.processing_time"
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    :label="item.label"
                                                    :value="item.value"
                                                    v-for="item of processingList"
                                                    :key="item.value"
                                                ></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    label="Status"
                                    align="center"
                                    prop="status"
                                    width="150"
                                >
                                    <template slot-scope="scope">
                                        <el-form-item
                                            label-width="0"
                                            :rules="[{ required: true }]"
                                            :prop="
                                                'attributes.' +
                                                scope.$index +
                                                '.status'
                                            "
                                        >
                                            <el-select
                                                v-model="scope.row.status"
                                                filterable
                                                size="small"
                                            >
                                                <el-option
                                                    label="On sale"
                                                    :value="10"
                                                    >On sale</el-option
                                                >
                                                <el-option
                                                    label="Off"
                                                    :value="60"
                                                    >Off</el-option
                                                >
                                            </el-select>
                                        </el-form-item>
                                    </template>
                                </el-table-column>
                                <!-- <el-table-column
                                    label="Customized"
                                    align="center"
                                    prop="value"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            effect="dark"
                                            :content="
                                                scope.row.metafields_label
                                            "
                                            :disabled="
                                                !Boolean(
                                                    scope.row.metafields_label
                                                )
                                            "
                                            placement="top"
                                        >
                                            <el-input
                                                placeholder="Please input Customized"
                                                maxlength="100"
                                                size="small"
                                                :disabled="disabled"
                                                v-model="
                                                    scope.row.metafields_label
                                                "
                                            ></el-input>
                                        </el-tooltip>
                                    </template>
                                </el-table-column> -->
                            </el-table>
                        </div>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="detailVisible = false">
                Close
            </el-button>
        </span>
    </el-dialog>
</template>
<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapState } from "vuex";
import tagsInput from "@/common/components/tags-input";
import imgUpload from "components/imgUpload";
export default {
    data() {
        return {
            oldAttribute: [],
            detailForm: {
                type: 1,
                goods_name: "", //产品名称
                catalog_id: [],
                category: "", // 产品分类
                spu: "",
                tags: [], // 标签
                keyword: [], // 关键字
                new_arrival_date: "",
                promotion: "",
                private_user_id: "",
                status: 1,
                goods_images: [], // 刊登图片
                goods_desc: "", // 产品描述
                attributes: [
                    {
                        images: [], // 产品图片
                        sku: "", //属性sku
                        weight: "", //属性名称
                        lwh: "",
                        price: 0.00, // 价格
                        mspr: 0.00,
                        stock: "", // 库存
                        delivery_time: "",
                        metafields: "",
                        status: 10,
                        delivery_type: 1,
                        processing_time:'',
                        value: ''
                    },
                ],
            },
            imagesList: [],
            updateImgVisible: false,
            tableItemIndex: "",
            shopList: [],
            loading: false,
            disabled: true,
            deliveryType: [
                /* {
                    label: "No matching data",
                    value: 0,
                }, */
                {
                    label: "自营定制",
                    value: 1,
                },
                {
                    label: "外包",
                    value: 2,
                },
                {
                    label: "代销标品",
                    value: 3,
                },
                {
                    label: "OEM",
                    value: 4,
                },
                {
                    label: "自营标品",
                    value: 5,
                },
                {
                    label: "代销定制",
                    value: 6,
                },
            ],
            processingList:[
                {
                    label: "1-3 days",
                    value: 1,
                },
                {
                    label: "3-5 days",
                    value: 2,
                },
                {
                    label: "5-7 days",
                    value: 3,
                },
                {
                    label: "More than 7 days",
                    value: 4,
                },
            ],
            combineList:[
                {
                    label: "Yes",
                    value: 1,
                },
                {
                    label: "No",
                    value: 2,
                },
            ],
        };
    },
    methods: {
        imagesChange(images) {
            this.detailForm.goods_images = images;
        },
        closeDialog() {
            this.$refs["detailForm"].clearValidate();
            this.$refs["detailForm"].resetFields();
            this.$emit("update:detailVisible", false);
        },
        updateImg(scope) {
            this.imagesList = scope.row.images;
            this.updateImgVisible = true;
            this.tableItemIndex = scope.$index;
        },
        imgUrl(params) {
            this.detailForm.attributes[this.tableItemIndex].images = params;
        },
        minusItem_attributeTable(scope) {
            if (this.detailForm.attributes.length > 1) {
                for (let i in this.detailForm.attributes) {
                    if (i == scope.$index) {
                        this.detailForm.attributes.splice(i, 1);
                    }
                }
            } else {
                return false;
            }
        },
        typeChange(val) {
            if (val == 1 && this.detailForm.attributes.length > 1) {
                this.oldAttribute = JSON.parse(
                    JSON.stringify(this.detailForm.attributes)
                );
                this.detailForm.attributes.splice(
                    1,
                    this.detailForm.attributes.length - 1
                );
            } else if (val == 2 && this.oldAttribute.length > 1) {
                for (let i = 1; i < this.oldAttribute.length; i++) {
                    this.detailForm.attributes.push(this.oldAttribute[i]);
                }
            }
        },
        productsSetList() {
            cmofferApi
                .productsSetList({}, "get", this.tableItem.id)
                .then((res) => {
                    if (res) {
                        this.detailForm = {
                            ...res.data,
                            platform_id: "",
                            shop_id: "",
                            listing_status: "draft",
                            goods_images: res.data.goods_images, // 刊登图片
                            sku: res.data.spu,
                            catalog_id: res.data.catalog,
                            category:
                                res.data.goods_category &&
                                res.data.goods_category.name_en,
                            attributes: res.data.goods_attribute,
                            type: res.data.goods_attribute.length <= 1 ? 1 : 2, //类型1-单品 2-多属性
                        };
                        this.detailForm.attributes.map((item) => {
                            if (item.metafields) {
                                let metafields = JSON.parse(
                                    JSON.stringify(item.metafields)
                                );
                                this.$set(
                                    item,
                                    "metafields_label",
                                    item.metafields
                                        .map((sItem) => sItem.key)
                                        .join(",")
                                );
                                item.metafields = metafields
                                    .map((sItem) => sItem.id)
                                    .join(",");
                            }
                            this.$set(
                                item,
                                "lwh",
                                `${item.length}${item.width ? " x " : ""}${
                                    item.width
                                }${item.height ? " x " : ""}${item.height}`
                            );
                            // 处理发货类型默认值
                            item.delivery_type == 0 && (item.delivery_type = "");
                            item.processing_time == 0 && (item.processing_time = "");
                        });
                        this.loading = false;
                    }
                });
        },
    },
    components: {
        imgUpload,
        tagsInput: tagsInput,
    },
    props: {
        detailVisible: Boolean,
        tableItem: Object,
        platform_id: Number,
        treeData: Array,
        goodsTagList: Array,
        cascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name_en",
                children: "cat_id",
                checkStrictly: true,
                multiple: true,
            },
        },
        tagsCascaderProps: {
            type: () => Object,
            default: {
                value: "id",
                label: "name",
                children: "child",
                checkStrictly: true,
                multiple: true,
            },
        },
    },
    computed: {
        ...mapState({
            setting: (state) =>
                Object.assign(JSON.parse(JSON.stringify(state.index.setting)), {
                    height: 400,
                    toolbar: false,
                    readonly: true,
                }),
        }),
    },
    watch: {
        detailVisible() {
            if (this.detailVisible) {
                // this.loading = true;
                this.productsSetList();
            }
        },
    },
};
</script>
<style lang="scss">
.detail {
    .container {
        width: 100%;
        .el-upload--picture-card {
            float: left !important;
            margin-right: 10px;
        }
        .uploadBox {
            .el-upload,
            .el-upload--text {
                width: 100%;
                height: 100%;
            }
        }
        .describeContent {
            line-height: 1.6;
        }
        .addAttribute {
            color: $color-primary;
            text-align: left;
        }

        .el-checkbox__label {
            font-size: 12px;
        }
        .table {
            .el-form-item {
                margin: 0;
            }
            .el-input-group__prepend {
                padding: 0 10px;
                & + .el-input__inner {
                    padding-right: 10px;
                }
            }
            .lwh_input {
                .el-input__inner {
                    padding: 0 5px 0 10px;
                }
            }
        }
    }
    .el-select--small {
        width: 100%;
    }
}
</style>
